(function componentForm($, Adzuki) {
	'use strict';

	var form = {
		name: 'ReservationCreateTripSummary',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var exclude_checkboxes  = $('.exclude-component').length;
		var excluded_components = excludedComponentsCount();


		$('.exclude-component').change(function onExcludeCheckboxChange(event) {
			excluded_components = excludedComponentsCount();

			// if the number of checked components, equals the number of components
			// then disable the create trip summary button
			if (excluded_components === exclude_checkboxes) {
				$('.create-trip-summary').prop('disabled', true);
			} else {
				$('.create-trip-summary').prop('disabled', false);
			}
		});
	};

	function excludedComponentsCount()
	{
		var excluded_count = 0;

		$('.exclude-component').each(function onEachCheckbox(i, elem)
		{
			if ($(elem).is(':checked')) {
				excluded_count++;
			}
		});

		return excluded_count;
	}

}(jQuery, window.Adzuki || {}));
